import { h, defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "sortIcon",
  emits: ["orderSort"],
  props: {
    isRest: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    let order = ref("");

    return () => {
      watch(
        () => props.isRest,
        (n, o) => {
          if (n) {
            order.value = "";
          }
        }
      );
      let topProps = {
        class: [
          "vxe-sort--asc-btn vxe-icon--caret-top",
          {
            "sort--active": order.value == "asc",
          },
        ],
        onClick: () => {
          if (order.value == "" || order.value == "desc") {
            order.value = "asc";
          } else {
            order.value = "";
          }
          emit("orderSort", order.value);
        },
      };
      let btmProps = {
        class: [
          "vxe-sort--desc-btn vxe-icon--caret-bottom",
          {
            "sort--active": order.value == "desc",
          },
        ],
        onClick: () => {
          if (order.value == "" || order.value == "asc") {
            order.value = "desc";
          } else {
            order.value = "";
          }
          emit("orderSort", order.value);
        },
      };
      return h("span", { class: "vxe-cell--sort vxe-cell--sort-vertical-layout" }, [h("i", topProps), h("i", btmProps)]);
    };
  },
});
